export default __webpack_public_path__ + "static/media/section2-7-img1.6c4786c7.png";